export const TERMS_OF_USE_URL =
  "https://drive.google.com/file/d/1kMTao3PPPdEcGi8j2PrLavvXcs3stX2I/view";

export const TERMS_OF_USE_EMBED_URL =
  "https://drive.google.com/file/d/1kMTao3PPPdEcGi8j2PrLavvXcs3stX2I/preview";

export const PRIVACY_POLICY_URL =
  "https://drive.google.com/file/d/1hvRUbjxFONSviFsxldlZgqdMiB0nQhGH/view";

export const PRIVACY_POLICY_EMBED_URL =
  "https://drive.google.com/file/d/1hvRUbjxFONSviFsxldlZgqdMiB0nQhGH/preview";
